import { render } from "./tipoTabela.vue?vue&type=template&id=0ed42260"
import script from "./tipoTabela.vue?vue&type=script&lang=js"
export * from "./tipoTabela.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__